// extracted by mini-css-extract-plugin
module.exports = {"modalBody":"Popup_modalBody__RO3HP","row":"Popup_row__Tgp1Y","img":"Popup_img__rXdRw","QR":"Popup_QR__fws2k","app":"Popup_app__A0Fh_"};